import React from "react";
import swot from '../../images/SWOT/swot.svg';
import styled from "styled-components";
import {BlueButton} from "./ButtonStyles";

const DisplaySwotButton = ({setOpenModal, name}) => {
    return (
        <Button onClick={() => setOpenModal(true)}>
            <img src={swot} alt={`ouvrir le swot de l'axe ${name}`}/>
            <h6> {name} </h6>
        </Button>
    )
}

export default DisplaySwotButton;

const Button = styled(BlueButton)`
  padding: 0.2rem 1rem;
  gap: 1rem;
  height: 2.2em;
`